module.exports = crypto;


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 3
// module chunks = 0